export default __webpack_public_path__ + "static/media/80t.4b5c6d45.jpg";